export enum FileExplorerStrategy {
  RouterConnected = 'routerConnected',
  Controlled = 'controlled',
  Stateful = 'stateful',
}
